package com.example.mystybag.communication.extensions

import com.example.mystybag.communication.defines.CommunicationDefines.Companion.PROTOCOL
import com.example.mystybag.communication.defines.CommunicationDefines.Companion.REST_HOST
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.auth.Auth
import io.ktor.client.plugins.auth.providers.BearerTokens
import io.ktor.client.plugins.auth.providers.bearer
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.URLProtocol
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

/**
 * @param host      REST host. Native uses [REST_HOST] (api.mystybag.com). Web overrides this
 *                  with the page's own origin so requests stay same-origin (see [basePath]).
 * @param protocol  URL scheme. Defaults to [PROTOCOL] (HTTPS).
 * @param port      Optional explicit port (web dev server runs on a non-default port).
 * @param basePath  Base path prepended to every request (must end with "/"). Web uses "/api/"
 *                  so a same-origin reverse proxy (nginx in prod, webpack devServer locally)
 *                  forwards to the real API. This avoids cross-origin requests, whose CORS
 *                  preflight behaves inconsistently in some mobile browsers ("Failed to fetch").
 */
fun HttpClientConfig<*>.configure(
    logger: Logger,
    token: String,
    host: String = REST_HOST,
    protocol: URLProtocol = PROTOCOL,
    port: Int? = null,
    basePath: String = "/",
) {
    defaultRequest {
        // Base URL as a string so Ktor's RFC-3986 path concatenation prepends
        // [basePath] to each (relative) request path. basePath must end with "/".
        val portPart = port?.let { ":$it" }.orEmpty()
        val normalizedBase = if (basePath.endsWith("/")) basePath else "$basePath/"
        url("${protocol.name}://$host$portPart$normalizedBase")
    }

    install(ContentNegotiation) {
        json(Json {
            prettyPrint     = true
            isLenient       = true
            encodeDefaults  = true
        })
    }

    install(Logging) {
        this.logger  = logger
        level   = LogLevel.ALL
    }

    install(Auth) {
        bearer {
            loadTokens {
                BearerTokens(token, "xyz111")
            }
        }
    }

}